@if (control(); as c) {
  @if (c.invalid && c.touched) {
    @if (c.errors?.['required']) {
      <small class="error-message">{{ label() || 'This field' }} is required.</small>
    } @else if (c.errors?.['email']) {
      <small class="error-message">Enter a valid email address.</small>
    } @else if (c.errors?.['minlength']) {
      <small class="error-message">Minimum length is {{ c.errors!['minlength'].requiredLength }}.</small>
    } @else if (c.errors?.['maxlength']) {
      <small class="error-message">Maximum length is {{ c.errors!['maxlength'].requiredLength }}.</small>
    } @else if (c.errors?.['min']) {
      <small class="error-message">Minimum value is {{ c.errors!['min'].min }}.</small>
    } @else if (c.errors?.['max']) {
      <small class="error-message">Maximum value is {{ c.errors!['max'].max }}.</small>
    } @else if (c.errors?.['pattern']) {
      <small class="error-message">Invalid format.</small>
    } @else if (c.errors?.['passwordStrength']) {
      <small class="error-message">Password must contain uppercase, lowercase, number, and special character.</small>
    } @else {
      <small class="error-message">Invalid value.</small>
    }
  }
}
